import { v4 as uuidv4 } from 'uuid';
export default () => {
  const uuid = uuidv4()
  return {
    $id: uuid,
    valueType: 'dateTimeRange',
    FormItemProps: {
      label: '日期时间区间',
      name: uuid,
    }
  }
};
